export var CreditFactorTypes = {
  AVG_AGE_OF_CREDIT: 'AVG_AGE_OF_CREDIT',
  NUM_DEROGATORY_ACCOUNTS: 'NUM_DEROGATORY_ACCOUNTS',
  NUM_INQUIRIES: 'NUM_INQUIRIES',
  NUM_MISSED_PAYMENTS: 'NUM_MISSED_PAYMENTS',
  NUM_OPEN_ACCOUNTS: 'NUM_OPEN_ACCOUNTS',
  CREDIT_UTILIZATION: 'CREDIT_UTILIZATION',
  NO_CHANGES: 'NO_CHANGES'
};
export var CreditChangeSentiments = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
};